module.exports = __webpack_public_path__ + "img/icon-patient-info.7a7c4564.svg";